import * as React from "react";
import { Container } from "./Container";

const keys = [
  "Email Address",
  "Property Address",
  "Bedroom Count",
  "Bathroom Count",
  "Square Feet",
  "For Sale Price",
  "Mobile Number",
  "Office Number",
  "Website",
  "Brokerage Address",
  "Accent Color"
];

export const CustomizeForm = () => (
  <form style={{ border: "solid 2px", padding: 10 }}>
    <div>
      <label>
        Name:
        <br />
        <input type="text" name="name" style={{ width: "100%" }} />
      </label>
      <label>
        Name:
        <br />
        <input type="text" name="name" />
      </label>
    </div>
    {renderFields()}
  </form>
);

const renderFields = () => (
    keys.map(key => (
        <div>
            <label>
            {key}
            <br />
            <input type="text" name="name" style={{ width: "200%" }} />
            </label>
        </div>
    ))
)



// WEBPACK FOOTER //
// ./src/components/marketing/components/CustomizeForm.js